import useCrmObjectTypeListingFilters from 'framework-listing-lib/hooks/useCrmObjectTypeListingFilters';
import { flattenFilterGroups } from 'framework-listing-lib/utils/filters';
import { useMemo } from 'react';
export default function useIsSearchingOrFiltering({
  isFoldersMode
} = {
  isFoldersMode: false
}) {
  const {
    filters
  } = useCrmObjectTypeListingFilters();
  const isSearchingForFiltering = useMemo(() => {
    if (filters.query || filters.quickFilters.length) return true;
    const filtersToCheck = flattenFilterGroups(filters.filterGroups).filter(filter => {
      const isArchivedFilter = filter.property === 'hs_archived';
      if (!isFoldersMode) return !isArchivedFilter;
      return !isArchivedFilter && filter.property !== 'hs_folder_id';
    });
    return filtersToCheck.length > 0;
  }, [filters.filterGroups, filters.query, filters.quickFilters.length, isFoldersMode]);
  return isSearchingForFiltering;
}